import { Button, OutlinedInput, Typography } from '@mui/material'
import React, { useMemo, useState } from 'react'
import fetchFromApi from '../../utils/apiFetch'
import { saveToLocalStorage } from '../../utils/localStorageActions'
import InputSelect from './InputSelect'

const InputSection = ({ setResults }) => {
  const [prompt, setPrompt] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  // DATA USED FOR FETCH. REFRESH STATE WHEN PROMPT CHANGES
  const data = useMemo(() => ({
    prompt: prompt,
    temperature: .45,
    max_tokens: 80,
    top_p: 1.0,
    frequency_penalty: 0.0,
    presence_penalty: 0.0,
  }), [prompt])

  // FETCH FUNCTION. USE DATA
  const fetchData = (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    fetchFromApi(data).then(data => {
      console.log('processing')
      let text = data.choices[0].text.replace('\\n\n\n', '\n')
      let newResult = {
        prompt: prompt,
        text: text
      }
      saveToLocalStorage(newResult)
      setResults(state => [...state, newResult])
      setLoading(false)
    }).catch(e => {
      console.error('ERROR PROCESSING DATA FROM API')
      setLoading(false)
      setError('Error occured. Try a different prompt or check network connection.')
    })

  }

  return (
    <>
      <Typography variant='body2' component='label' sx={{ display: 'inline' }}>ENTER PROMPT</Typography>
      <InputSelect setPrompt={setPrompt} />

      {/* ===================================== FORM ===================================== */}
      <form onSubmit={fetchData}>
        {/* ================================= TEXT INPUT ================================== */}
        <OutlinedInput
          placeholder='Ask anything, for example:(List top movies of 2018)'
          fullWidth
          multiline
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          sx={{ fontSize: '16px !important' }} />

        {/* =============================== SUBMIT BUTTON ================================= */}
        <Button
          color='warning'
          variant='contained'
          type='submit'
          value='submit'
          disabled={loading}
          fullWidth
          size='large'
          sx={{ my: 2, fontWeight: '600' }}>
          {loading ? 'Fetching...' : 'Submit'}
        </Button>

        {/* ================================= ERROR TEXT ================================== */}
        <Typography variant='body2' color='error'>{error || ""}</Typography>

      </form>
    </>

  )
}

export default InputSection